import React from "react";

const NavItem = ({
  children,
  isActive = false,
  isExpanded = true,
  className = "",
  onClick,
  title,
  ...props
}) => {
  const baseClasses = "flex items-center px-4 py-3 text-sm transition-colors cursor-pointer";
  
  const defaultActiveClasses = isActive
    ? "bg-orange-500 text-white"
    : "text-gray-300 hover:bg-gray-800 hover:text-white";

  const activeClasses = isActive ? "bg-orange-500 text-white" : "";
  const finalClasses = className 
    ? `${baseClasses} ${className} ${activeClasses}`.trim()
    : `${baseClasses} ${defaultActiveClasses}`;

  return (
    <div
      className={finalClasses}
      onClick={onClick}
      title={!isExpanded ? title : ""}
      {...props}
    >
      {children}
    </div>
  );
};

export default NavItem;
